const LINK_RE = /(\b(https?|):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;\(\)]*[-A-Z0-9+&@#\/%=~_|])/gi;
const SIMPLE_LINK_RE = /[^\/\(]*(www.[-A-Z0-9+&@#\/%?=~_|!:,.;\(\)]*[-A-Z0-9+&@#\/%=~_|])/gi;

export function withLinks(content: string | null) {
  if (!content) return '';
  return content
    .replace(LINK_RE, '<a target="_blank" href="$1">$1</a>')
    .replace(SIMPLE_LINK_RE, '<a target="_blank" href="https://$1">$1</a>');
}
